export default __webpack_public_path__ + "static/staff-presentation-fb1a061c1ad1e99ef77d99fa80a08161.png";